import {Form} from "kaiju.core"
import {CustomerFieldStore} from "./CustomerField";
import {Manufacturer} from "./Manufacturer";
import {TextStore} from "./Text";

export const initFields = () => {
    Form.idMap["customer"] = CustomerFieldStore
    Form.kindMap["manufacturer"] = Manufacturer
    Form.kindMap["text"] = TextStore
}